// app/javascript/components/selectize.js
import 'flatpickr/dist/flatpickr.min.js'; // scroll to node folder (1) get that path
import 'flatpickr/dist/flatpickr.min.css'; // scroll to node folder (1) get that path

const flatpickr = () => {
  // this works - flatpickr is available to HTML but not Turbo yet
};

export { flatpickr }; //# app/javascript/packs/application.js will call that const
